import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Divider } from '../components/ui/Divider';
export function EmotionalOpening() {
  return <section id="el-metodo" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-130">
      <FadeIn data-id="element-131">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-brand-burgundy leading-tight mb-10" data-id="element-132">
          ¿Alguna vez has sentido que amas profundamente a tu bebé, pero te
          preguntas si realmente estás creando una conexión con él?
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-133">
        <FadeIn delay={0.2} className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-134">
          <p data-id="element-135">
            Cada día acaricias tu vientre. Le hablas. Piensas en él. Imaginas
            cómo será cuando finalmente lo tengas en tus brazos.
          </p>
          <p data-id="element-136">
            Pero cuando te quedas sola por la noche aparecen preguntas que pocas
            madres se atreven a decir en voz alta:
          </p>

          <blockquote className="border-l-4 border-brand-rose pl-6 space-y-4 my-8 font-serif text-xl text-brand-burgundy italic" data-id="element-137">
            <p data-id="element-138">"¿Mi bebé puede sentir lo que siento?"</p>
            <p data-id="element-139">"¿Estoy haciendo suficiente para conectar con él?"</p>
            <p data-id="element-140">"¿Cómo puedo crear un vínculo fuerte antes de que nazca?"</p>
            <p data-id="element-141">"¿Y si un día olvido todos estos momentos?"</p>
          </blockquote>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-142">
          <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-143">
            <div className="absolute inset-0 bg-brand-burgundy/10 mix-blend-overlay z-10" data-id="element-144"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rthX6ajas2QRfLt1fdjb8r/ChatGPT_Image_Jun_21,_2026,_10_43_17_PM.png" alt="Mujer embarazada leyendo y conectando con su bebé" className="w-full h-auto object-cover" data-id="element-145" />
          </div>
        </FadeIn>
      </div>

      <Divider className="mt-16" data-id="element-146" />
    </section>;
}